"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLatest = void 0;
var useLatest_1 = require("./useLatest");
Object.defineProperty(exports, "useLatest", { enumerable: true, get: function () { return useLatest_1.useLatest; } });
//# sourceMappingURL=index.js.map